import z from 'zod';

export const parseEnv = <T extends z.ZodRawShape>(schema: T): z.infer<z.ZodObject<T>> => {
  const EnvSchema = z.object(schema);

  const envVarsUnparsed = (import.meta as unknown as { env: Record<string, string | undefined> })
    .env;

  const envVars = Object.entries(envVarsUnparsed).reduce<Record<string, string | undefined>>(
    (acc, curr) => {
      const [key, value] = curr;
      if (key.startsWith('VITE_')) {
        acc[key.replace('VITE_', '')] = value;
      }
      return acc;
    },
    {} satisfies Record<string, string | undefined>
  );

  const parsedEnv = EnvSchema.safeParse(envVars);

  if (!parsedEnv.success) {
    throw new Error(
      `Invalid env provided.
The following variables are missing or invalid:
${Object.entries(parsedEnv.error.flatten().fieldErrors)
  .map(([k, v]) => `- ${k}: ${v}`)
  .join('\n')}
`
    );
  }

  return parsedEnv.data;
};
